// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .error {
    @media (min-width: 1025px) {
      margin-left: 30%;
    }
    @media (max-width: 1024px) {
      margin-left: 25%;
    }
    @media (max-width: 768px) {
      margin-left: 35%;
    }
    @media(max-width: 360px) {
      margin-left: 25%;
    }
  }
   */
.error-icon {
  display: block;
  margin: 0 auto;
}

.error-text {
  display: block;
  text-align: center;
}

.media-body {
  margin-top: 8px;
}

.face-id-error {
  margin-top: 20px;
}

.retry-btn {
  width: 100%;
  background: #00943E;
  color: white;
  height: 50px;
  border-radius: 7.21622px;
  flex: none;
  order: 3;
  align-self: center;
  margin-top: 20px;
  margin-bottom: 30px;
}

.btn-success:hover, .btn-success:focus {
  background: #00943E;
  border: #00943E;
  color: white;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
